import './styles.scoped.css'
import {Typography, Button, Modal} from '@mui/material'
import {useGlobalStates} from '../../../../contexts/GlobalStatesContext'
import {accountApi} from '../../../../services'
import {parseError} from '../../../../utils/helpers'

export default ({open, setOpen, data, loadData}) => {
    const {setLoading, setMessageBox} = useGlobalStates()

    const handleOk = () => {
        setLoading(true)
        accountApi
            .cancelInvitation(data?.id)
            .then(() => {
                setLoading(false)
                setOpen(false)
                setMessageBox({
                    status: 'success',
                    title: 'Invitation Canceled',
                    description: `The team member invitation to ${
                        data?.first_name
                    } has been canceled. You can send a new invitation anytime if needed.`,
                })
                loadData()
            })
            .catch(error => {
                setLoading(false)
                setOpen(false)
                const {title, description} = parseError(error)
                if (description) {
                    setMessageBox({status: 'error', title, description})
                }
            })
    }

    return (
        <Modal open={open}>
            <div className="container">
                <div className="content">
                    <div className="title">
                        <Typography variant="h6" color="text.primary">
                            {`Cancel Invitation to "${data?.first_name}" ?`}
                        </Typography>
                    </div>
                    <br />
                    <Typography variant="body2" color="text.primary" style={{textAlign: 'center'}}>
                        Are you sure you want to cancel this invitation? The team member will no longer be able to join using this link. You can
                        always send a new invitation if needed.
                    </Typography>
                    <br />
                    <div className="actions">
                        <Button variant="outlined" fullWidth onClick={() => setOpen(false)}>
                            Keep Invitation
                        </Button>
                        <Button variant="contained" fullWidth color="error" onClick={handleOk}>
                            Cancel Invitation
                        </Button>
                    </div>
                </div>
            </div>
        </Modal>
    )
}
